export enum NotificationSource {
    DesktopToMobile = 1,
    MobileToDesktop = 2,
    SystemToMobile = 11,
    SystemToDesktop = 12,
}
